import { jsx, jsxs } from 'react/jsx-runtime';
import { getEntityImage } from '../../utils/assetUtils.js';
import '../../analytics/events.js';
import '../../node_modules/tslib/tslib.es6.js';
import 'uuid';
import 'lodash/includes';
import '../../types/filters.js';
import '../../utils/brandclubStoreConfigUtils.js';
import 'numeral';
import { formatMoney } from '../../utils/stringUtils.js';
import '../../utils/broadcast.js';
import '../../utils/constants/Constants.js';
import 'awesome-phonenumber';
import 'react';
import 'lodash/isEqual';
import 'lodash/get';
import 'lodash/orderBy';
import '@splitsoftware/splitio-react';
import '@tanstack/react-query';
import '../../Auth/index.js';
import '../../types/Campaign.js';
import '../../types/product.js';
import '../../api/graphQl/brand.js';
import '../../api/graphQl/product.js';
import '../../api/cache/appConfigQueryOptions.js';
import '@brandclub/types';
import 'lodash/omitBy';
import 'lodash/isNil';
import '../../utils/logger.js';
import { FallbackImage } from '../../Components/FallbackImage.js';
import { ShoppingBag, Package, Store, CheckCircle, XCircle, Truck, Clock } from 'lucide-react';

const StatusBadge = ({ status }) => {
    const statusConfig = {
        DELIVERED: {
            icon: CheckCircle,
            label: 'Delivered',
            bgColor: '#dcfce7',
            textColor: '#166534',
            iconColor: '#16a34a',
        },
        CANCELLED: {
            icon: XCircle,
            label: 'Cancelled',
            bgColor: '#fee2e2',
            textColor: '#991b1b',
            iconColor: '#dc2626',
        },
        IN_TRANSIT: {
            icon: Truck,
            label: 'In Transit',
            bgColor: '#dbeafe',
            textColor: '#1e40af',
            iconColor: '#2563eb',
        },
        PROCESSING: {
            icon: Clock,
            label: 'Processing',
            bgColor: '#fef3c7',
            textColor: '#92400e',
            iconColor: '#d97706',
        },
        UNKNOWN: {
            icon: Clock,
            label: 'Pending',
            bgColor: '#f3f4f6',
            textColor: '#374151',
            iconColor: '#6b7280',
        },
    };
    const config = statusConfig[status];
    const Icon = config.icon;
    return (jsxs("div", Object.assign({ style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '4px',
            padding: '4px 10px',
            borderRadius: '9999px',
            backgroundColor: config.bgColor,
            color: config.textColor,
            fontSize: '12px',
            fontWeight: 500,
        } }, { children: [jsx(Icon, { size: 14, color: config.iconColor }), config.label] })));
};
const OrderTypeBadge = ({ orderType }) => {
    if (!orderType)
        return null;
    const isOnline = orderType === 'ONLINE';
    const Icon = isOnline ? Package : Store;
    return (jsxs("div", Object.assign({ style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '4px',
            padding: '4px 10px',
            borderRadius: '9999px',
            backgroundColor: '#f3f4f6',
            color: '#374151',
            fontSize: '12px',
            fontWeight: 500,
        } }, { children: [jsx(Icon, { size: 14, color: "#6b7280" }), isOnline ? 'Online' : 'In-Store'] })));
};
const OrderCard = ({ order }) => {
    const { orderId, orderDate, retailerId, retailerDisplayName, retailerName, shipmentStatus, orderType, products } = order;
    const formattedDate = new Date(orderDate).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    });
    const totalAmount = products.reduce((sum, p) => sum + p.retailPrice * p.quantity, 0);
    const totalItems = products.reduce((sum, p) => sum + p.quantity, 0);
    const retailerLogo = getEntityImage(retailerId, 'retailer');
    const displayName = retailerDisplayName || retailerName;
    return (jsxs("div", Object.assign({ style: {
            border: '1px solid #e5e7eb',
            borderRadius: '12px',
            backgroundColor: '#ffffff',
            overflow: 'hidden',
            transition: 'box-shadow 0.2s ease',
        }, className: "tw:hover:shadow-md" }, { children: [jsxs("div", Object.assign({ style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '12px 16px',
                    backgroundColor: '#f9fafb',
                    borderBottom: '1px solid #e5e7eb',
                } }, { children: [jsxs("div", Object.assign({ style: { display: 'flex', alignItems: 'center', gap: '12px' } }, { children: [jsx("img", { src: retailerLogo, alt: displayName, style: {
                                    width: '36px',
                                    height: '36px',
                                    borderRadius: '8px',
                                    objectFit: 'contain',
                                    backgroundColor: '#fff',
                                    border: '1px solid #e5e7eb',
                                } }), jsxs("div", { children: [jsx("div", Object.assign({ style: { fontWeight: 600, fontSize: '14px', color: '#111827' } }, { children: displayName })), jsx("div", Object.assign({ style: { fontSize: '12px', color: '#6b7280' } }, { children: formattedDate }))] })] })), jsxs("div", Object.assign({ style: { display: 'flex', alignItems: 'center', gap: '8px' } }, { children: [jsx(OrderTypeBadge, { orderType: orderType }), jsx(StatusBadge, { status: shipmentStatus })] }))] })), jsx("div", Object.assign({ style: { padding: '12px 16px' } }, { children: jsxs("div", Object.assign({ style: { display: 'flex', flexDirection: 'column', gap: '12px' } }, { children: [products.slice(0, 3).map((product, idx) => (jsxs("div", Object.assign({ style: { display: 'flex', gap: '12px' } }, { children: [jsx("div", Object.assign({ style: {
                                        width: '64px',
                                        height: '64px',
                                        borderRadius: '8px',
                                        backgroundColor: '#f9fafb',
                                        border: '1px solid #e5e7eb',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        flexShrink: 0,
                                        overflow: 'hidden',
                                    } }, { children: product.imageUrl ? (jsx(FallbackImage, { src: product.imageUrl, fallbackImage: product.imageUrl.replace('media.brandclub.com', 'media-api.brandclub.com'), alt: product.title || 'Product', style: {
                                            maxWidth: '100%',
                                            maxHeight: '100%',
                                            objectFit: 'contain',
                                        } })) : (jsx(ShoppingBag, { size: 24, color: "#9ca3af" })) })), jsxs("div", Object.assign({ style: { flex: 1, minWidth: 0 } }, { children: [jsx("div", Object.assign({ style: {
                                                fontSize: '14px',
                                                fontWeight: 500,
                                                color: '#111827',
                                                display: '-webkit-box',
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: 'vertical',
                                                overflow: 'hidden',
                                                lineHeight: '1.4',
                                            } }, { children: product.title || 'Product' })), product.brandName && (jsx("div", Object.assign({ style: { fontSize: '12px', color: '#6b7280', marginTop: '2px' } }, { children: product.brandName }))), jsxs("div", Object.assign({ style: {
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '8px',
                                                marginTop: '4px',
                                            } }, { children: [jsx("span", Object.assign({ style: { fontSize: '14px', fontWeight: 600, color: '#111827' } }, { children: formatMoney(product.retailPrice) })), product.quantity > 1 && (jsxs("span", Object.assign({ style: { fontSize: '12px', color: '#6b7280' } }, { children: ["x", product.quantity] })))] }))] }))] }), `${product.retailerSku}-${idx}`))), products.length > 3 && (jsxs("div", Object.assign({ style: {
                                fontSize: '13px',
                                color: '#6b7280',
                                textAlign: 'center',
                                padding: '8px',
                                backgroundColor: '#f9fafb',
                                borderRadius: '6px',
                            } }, { children: ["+", products.length - 3, " more item", products.length - 3 > 1 ? 's' : ''] })))] })) })), jsxs("div", Object.assign({ style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '12px 16px',
                    backgroundColor: '#f9fafb',
                    borderTop: '1px solid #e5e7eb',
                } }, { children: [jsxs("div", Object.assign({ style: { fontSize: '13px', color: '#6b7280' } }, { children: [totalItems, " item", totalItems !== 1 ? 's' : ''] })), jsxs("div", Object.assign({ style: { fontSize: '16px', fontWeight: 600, color: '#111827' } }, { children: ["Total: ", formatMoney(totalAmount)] }))] }))] })));
};
const OrderCardList = ({ orders }) => {
    if (!orders || orders.length === 0)
        return null;
    return (jsx("div", Object.assign({ style: { display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '16px' } }, { children: orders.map((order, idx) => (jsx(OrderCard, { order: order }, `${order.orderId}-${order.retailerId}-${idx}`))) })));
};

export { OrderCard, OrderCardList };
//# sourceMappingURL=OrderCard.js.map
